import Typography from 'components/Typography';
import { formatMileage } from './utils';
import { VehicleInformationCardProps } from './types';
import { CarInformationContainer, GeneralInfo } from './styles';

const VehicleInformationCard = ({ vehicleInformation }: VehicleInformationCardProps) => {
  const { info } = vehicleInformation;

  if (!info) return null;

  return (
    <CarInformationContainer>
      <GeneralInfo>
        <Typography id='year-make-model' variant='heading' size='xs' color='strong'>{`${
          info.year ?? ''
        } ${info.make ?? ''} ${info.model ?? ''}`}</Typography>
        {
          <Typography size='sm' color='weak' id='trim-mileage'>
            {info.trim ?? ''}
            {info.trim && info.mileage && <> &bull; </>}
            {info.mileage ? formatMileage(info.mileage) : ''}
          </Typography>
        }
      </GeneralInfo>

      {
        <Typography emphasis='strong' size='sm' color='strong' id='price'>
          {info.price && <> From ${info.price ? info.price.toLocaleString() : ''}</>}
        </Typography>
      }
    </CarInformationContainer>
  );
};

export default VehicleInformationCard;
